import { z } from 'zod';
import { IsoDateSchema } from './common';

export const TaxStatusSchema = z.enum(['presentado', 'proximo', 'no_aplica']);
export type TaxStatus = z.infer<typeof TaxStatusSchema>;

export const PeriodKindSchema = z.enum(['monthly', 'quarterly', 'annual']);
export type PeriodKind = z.infer<typeof PeriodKindSchema>;

export const CreateTaxObligationSchema = z.object({
  modelCode: z.string().min(1),
  description: z.string().min(1),
  periodKind: PeriodKindSchema,
  fiscalYear: z.number().int().min(2000).max(2100),
  periodLabel: z.string().min(1),
  dueDate: IsoDateSchema,
  status: TaxStatusSchema.default('proximo'),
  estimatedAmount: z.number().nullish(),
  actualAmount: z.number().nullish(),
  notes: z.string().nullish(),
});
export type CreateTaxObligationRequest = z.infer<typeof CreateTaxObligationSchema>;

export const UpdateTaxObligationSchema = CreateTaxObligationSchema.partial();
export type UpdateTaxObligationRequest = z.infer<typeof UpdateTaxObligationSchema>;
